module.exports = __webpack_public_path__ + "img/digital-agency.e407e1da.png";